<script>
import IconYellowStar from "@js/components/Icons/IconYellowStar.vue";
import IconDoubleAngleRight from "@js/components/Icons/IconDoubleAngleRight.vue";

export default {
    name: "FeedbackBlock",
    components: {IconDoubleAngleRight, IconYellowStar},
    props: {
        maxLength: {
            type: Number,
            default: 256,
        },
        name: {
            required: true,
            type: String,
        },
        date: {
            required: true,
            type: String,
        },
        text: {
            required: true,
            type: String,
        },
        link: {
            required: true,
            type: String,
            default: '#'
        },
    },
    methods: {
        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.slice(0, maxLength) + '...';
            }
            return text;
        },
    },
};
</script>

<template>
    <div class="flex flex-col flex-grow border-lg border border-gray-200 rounded-xl shadow p-5 max-w-[550px] mb-2">
        <div>
            <div class="flex items-center justify-between mb-5">
                <div>
                    <div class="flex items-center mb-2">
                        <IconYellowStar class="w-6 h-6 me-1 text-amber-500" v-for="i in 5"/>
                    </div>
                    <p class="text-xs md:text-sm font-normal text-gray-500 leading-tight">
                        {{ name }}
                    </p>
                </div>
                <div class="flex flex-col items-end">
                    <img src="@img/brands/big/yandex.webp"
                         class="h-[24px] w-[72px] object-contain mb-2"
                         alt="yandex" title="yandex">
                    <p class="text-xs md:text-sm font-normal text-gray-500 leading-tight">
                        {{ date }}
                    </p>
                </div>
            </div>
            <div class="mb-5">
                <p class="text-xs md:text-sm font-normal text-gray-500 leading-tight">
                    {{ truncateText(text, maxLength) }}
                </p>
            </div>
        </div>
        <div class="mt-auto">
            <a :href="link" target="_blank" rel="nofollow"
               class="group text-black text-sm font-medium flex items-center md:hover:text-navHoverColor transition">
                Перейти в источник
                <IconDoubleAngleRight class="md:group-hover:text-navHoverColor w-4 h-4 ms-0.5 transition"/>
            </a>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
